import { Input, Directive, Output, EventEmitter } from '@angular/core';
@Directive({selector: '[isLast]'})
export class LastDirective {
   @Input() isLast: boolean;
   @Output() lastDone: EventEmitter<boolean> = new EventEmitter<boolean>();
   // tslint:disable-next-line:use-life-cycle-interface
   ngOnInit() {
     if (this.isLast) {
       this.lastDone.emit(true);
     }
   }
}



// WEBPACK FOOTER //
// ./src/app/directive/LastDirective.directive.ts